import * as React from "react";

const SvgFolder = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}><path data-name="Path 8330" d="M0 0h20v20H0z" fill="none" /><path data-name="Path 8331" d="M8.4 4H3.6a1.55 1.55 0 0 0-1.592 1.5L2 14.5A1.557 1.557 0 0 0 3.6 16h12.8a1.557 1.557 0 0 0 1.6-1.5V7a1.557 1.557 0 0 0-1.6-1.5H10z" fill="#20a3a9" /></svg>;

export default SvgFolder;